import { render, staticRenderFns } from "./InviteAccountModal.vue?vue&type=template&id=1c5a5af2"
import script from "./InviteAccountModal.vue?vue&type=script&lang=js"
export * from "./InviteAccountModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports